/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedBBDocUpdateRequest } from '../types/PatchedBBDocUpdate';
import type { BBDocUpdateResponse } from '../types/BBDocUpdate';

export type BbDocsPartialUpdateRequest = PatchedBBDocUpdateRequest;
export type BbDocsPartialUpdateResponse = BBDocUpdateResponse;

export type BbDocsPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/bb_docs/{id}/
 *
 * ```yaml
 * operationId: bb_docs_partial_update
 * tags:
 *   - bb_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/BBDocUpdate'
 *     description: ''
 * ```
 */
export const bbDocsPartialUpdateOperation = ({ id, ...rest }: BbDocsPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/bb_docs/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/bb_docs/{id}/' };
  };

/**
 * PATCH /dmx-server/bb_docs/{id}/
 *
 * ```yaml
 * operationId: bb_docs_partial_update
 * tags:
 *   - bb_docs
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocUpdate'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocUpdate'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedBBDocUpdate'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/BBDocUpdate'
 *     description: ''
 * ```
 */
export const bbDocsPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: BbDocsPartialUpdateQuery;
  request: PatchedBBDocUpdateRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<BBDocUpdateResponse>> => {
  const operation = bbDocsPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
